export default __webpack_public_path__ + "static/media/hht1_home_img_EP13.4d0e2afa.png";